import React, { useEffect, Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import { getParameterByName , getUrlParameter} from "../services/utils";
import config from '../config'
import { pureCloudService } from "../services/purecloud";
import constants from '../constants'
import appStorage from '../services/appstorage'
import backendAPI from '../services/backend'
import {__version__} from '../__version__'



const Main = () => {
    const history = useHistory()

    const fetchDisclaimerContent = async () => {
        try {
            const disclaimerResponse = await backendAPI.getDisclaimerContent(tempToken);
            console.log(`PrivacyDisclaimer ${JSON.stringify(disclaimerResponse)}`);
            setConsentResponse(disclaimerResponse.consentSettings);
            appStorage.setItem(constants.SESSION_KEY_DISCLAIMER_RESPONSE, JSON.stringify(disclaimerResponse.consentSettings))
        } catch (error) {
            setError(`An error occured while fetching data:${JSON.stringify(error.message)}`)
            console.log(error)
        } finally {
            setIsWaitingModalOpen(false)
        }

    }

    const notifyUserLogin = async (tempToken) => {
        try {
            console.log("Calling notify user login")
            appStorage.setItem(constants.GC_TOKEN, tempToken);
            localStorage.setItem(constants.GC_TOKEN, tempToken);
            const notifyLoginResponse = await backendAPI.postUserLogin(tempToken);
            appStorage.setItem(constants.SESSION_KEY_USER_LOGIN_RESPONSE, JSON.stringify(notifyLoginResponse))
            appStorage.setItem(constants.SESSION_KEY_CONSENTAGREED, true);
            console.log(`notifyUserLogin ::: Notify user login response ${JSON.stringify(notifyLoginResponse)}`);
            //setLoginResponse(notifyLoginResponse)
            console.log('Navigating to Conversation Page')
            history.push("/conversations");
            
            //history.push("/management/users/");
            
        } catch (error) {
            console.log(`An error occured while fetching data:${JSON.stringify(error.message)}`)
            console.log(error)
        } finally {
            //setSendingLogin(false)
        }

    }

    useEffect(() => {
        const init = async () => {
            console.log(`main.useEffect.init with version ${__version__}`);
            var hash = window.location.hash.substring(1);
            var params = {}
            hash.split('&').map(hk => { 
            let temp = hk.split('='); 
                params[temp[0]] = temp[1] 
            });
            console.log(params); //Here are the params to use
            const queryString = window.location.hash
            console.log(queryString);
            console.log(window.location);
            
            const urlParams = new URLSearchParams(queryString);
            console.log(`urlParams are ${urlParams}`);
            console.log(`window.locations are ${window.location}`);
            console.log(`URL Params are ${getUrlParameter(constants.GC_ACCESS_TOKEN)}`);
            console.log(params.access_token);
            const token = params.access_token;
            const error = params.error;
            console.log(error);
            let environment = new URLSearchParams(window.location.search).get("environment");
            let sessionEnvironment = appStorage.getItem(constants.GC_ENVIRONMENT);
            console.log(`Before Check :: Environment is ${environment}`)
            console.log(`Before Check :: sessionEnvironment is ${sessionEnvironment}`)
            if(sessionEnvironment){
                // do nothing
                environment = sessionEnvironment;
            }else{
                if(environment){
                    appStorage.setItem(constants.GC_ENVIRONMENT,environment);
                }else{
                    console.log(`Environment not Found hence resetting it to default environment`);
                    appStorage.setItem(constants.GC_ENVIRONMENT,config.defaultEnvironment);
                }
            }
            console.log(`Environment is ${environment}`);

            console.log(`token: ${token}`);
            if (token){
                console.log(`moving to Disclaimer Page`);
                appStorage.setItem(constants.GC_TOKEN,getParameterByName(constants.GC_ACCESS_TOKEN));
                localStorage.setItem(constants.GC_TOKEN, getParameterByName(constants.GC_ACCESS_TOKEN));
                //fetchDisclaimerContent();
                notifyUserLogin(token);
                //history.push({ pathname: '/disclaimer', state: { token: token } })
                
            }else{
                console.log('Main.js:::Token is empty , Trying to Login.');
                history.push('/login');
            }
            
            console.log(getParameterByName(constants.GC_ACCESS_TOKEN));

            if (getParameterByName(constants.GC_ACCESS_TOKEN)) {
                appStorage.setItem(constants.GC_TOKEN,getParameterByName(constants.GC_ACCESS_TOKEN));
                localStorage.setItem(constants.GC_TOKEN, getParameterByName(constants.GC_ACCESS_TOKEN));
            }
            
           if (appStorage.getToken()) {
                try {
                    console.log("Initialize");
                    console.log(`Environment now is ${appStorage.getItem(constants.GC_ENVIRONMENT)}`);
                    const loggedInUser = await pureCloudService.getCurrentUserDetails(
                        appStorage.getItem(constants.GC_ENVIRONMENT),
                        appStorage.getToken()
                    );
                    console.log(`Current logged in user is : ${JSON.stringify(loggedInUser)}`);
                    const divisionId = loggedInUser.division.id;
                    console.log("User division ID", divisionId);
                    appStorage.setItem(constants.GC_DIVISION_ID, divisionId);

                    const roles = await pureCloudService.getRoles(
                        appStorage.getItem(constants.GC_ENVIRONMENT),
                        usertoken,
                        loggedInUser.id
                    );
                    console.log("roles", roles);
                    console.log(`config : ${JSON.stringify(config)}`);
                const isUser = roles.roles.find((r) => r.name === config.userRole)? true: false;

                console.log("isUser", isUser);

                if (isUser) {
                    history.push("/home");
                } else {
                    history.push("/unauthorized", "Unauthorized Genesys Cloud user");
                }
            }catch(error){
                console.log("Error : " + error);
                if (error.status === 401) {
                    //history.push("/login");
                }else{
                    history.push("/unauthorized", error.message);
                } 
            }
        }else{
               // history.push("/login");
        }};
        init()
    }, [history])

    return (<Fragment></Fragment>)
}

export default Main